
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cgvS_45Iady8eDZOxEmtpL3AE8FBmtmyHFJT9yNsjHx7mg2oMeta } from "/opt/bookandgolf-front/pages/cgv.vue?macro=true";
import { default as faqloWnhHb00VSlaJ3RHml1qTBhB2cH4yaJVjVB3w8JHo8Meta } from "/opt/bookandgolf-front/pages/faq.vue?macro=true";
import { default as indexWMfzC22WocfikVFNkPboc5lAgLlvh6ZgRIU2mov5eokMeta } from "/opt/bookandgolf-front/pages/index.vue?macro=true";
import { default as loginBbnNcaHy0yOuTpg80Z5dIb7qxb1pINnjPgHQ4ZsYdqgMeta } from "/opt/bookandgolf-front/pages/login.vue?macro=true";
import { default as reset8vqsmK42PmtidkjE4sdRZ6i9Ah21Nkp_45L5Sa24FdNlYMeta } from "/opt/bookandgolf-front/pages/reset.vue?macro=true";
import { default as searchPUM0qx_UUMjaNmP4kn_45WCl2NX9Pw4jhZLa7N6SDBZGgMeta } from "/opt/bookandgolf-front/pages/search.vue?macro=true";
import { default as join_45usbuQsC7ltwUZVqJd2L1gbZqr1wQf8SahP_4548uYFPHS90Meta } from "/opt/bookandgolf-front/pages/join-us.vue?macro=true";
import { default as profile2XF7ZogA6btWpnFBtKXPbIJ55bcRAPlUQQ6MT05OeWYMeta } from "/opt/bookandgolf-front/pages/profile.vue?macro=true";
import { default as about_45ustfisIEJu3yI4uMs_45NdrrLMOFWEvzkI4gwPpR5XVLYTUMeta } from "/opt/bookandgolf-front/pages/about-us.vue?macro=true";
import { default as registerKzLIv0GE_4Sv7FIcLy6oqk_OmjdRNh2werlwy9dGBjsMeta } from "/opt/bookandgolf-front/pages/register.vue?macro=true";
import { default as validateTU8A_j8Hyz8dGPUlBIm90Ssoh1taW4LAWNoehISMauIMeta } from "/opt/bookandgolf-front/pages/validate.vue?macro=true";
import { default as favoritesd6mcePiIl9p18fBYY0U1qO9e7VvTk0coxtKFOs_DgRcMeta } from "/opt/bookandgolf-front/pages/favorites.vue?macro=true";
import { default as promotionsCKQJrIv_hqiudeqn5eas4b0FzYYPucC1X0bkAMBlneYMeta } from "/opt/bookandgolf-front/pages/promotions.vue?macro=true";
import { default as legal_45noticeXOFtj9Yv5KCeP_45J6rb3wOAM_kAGCkVKDfAqckhT_7RYMeta } from "/opt/bookandgolf-front/pages/legal-notice.vue?macro=true";
import { default as _91id_93_PqRDmPLlwZgQbf7UGCZ7to6T6Ge_45TvxPINKj7S_456hwMeta } from "/opt/bookandgolf-front/pages/product/[id].vue?macro=true";
import { default as _91id_93mu3grqr0UVJ_FlFy2aZ_454NEE2OZmeaT8rNAZ2z8A9jAMeta } from "/opt/bookandgolf-front/pages/ratings/[id].vue?macro=true";
import { default as kadyg9jgc00RJ9XXfhyFiRW1SVqcSN1vKrF3nE06FoZwZF4Meta } from "/opt/bookandgolf-front/pages/partners/kady.vue?macro=true";
import { default as basketyzCVsfhLtQbnvXWV_45NPfvB6KVdfTpjtce0x3GaQ6smYMeta } from "/opt/bookandgolf-front/pages/shopping-cart/basket.vue?macro=true";
import { default as paymentgSMn6REh4wFWamVlyhPsiWR1_45390GBAvDZco72v9rAwMeta } from "/opt/bookandgolf-front/pages/shopping-cart/payment.vue?macro=true";
import { default as vouchertWckK_456hu_xbX2dKkmrYRkQuc_Hr43l0UQdpPAZGp64Meta } from "/opt/bookandgolf-front/pages/shopping-cart/voucher.vue?macro=true";
import { default as confirmationBg5TtA17JiG10KQFv3dTvN9AtTbfTdLNHJSgkdOpUpcMeta } from "/opt/bookandgolf-front/pages/shopping-cart/confirmation.vue?macro=true";
import { default as _91id_935CyMN7fh_45R2H2g_1kpNhduLF6c1Lrsf6FrKrdD2gio0Meta } from "/opt/bookandgolf-front/pages/shopping-cart/pricing/[id].vue?macro=true";
import { default as shopping_45cartkNGH535wKrdsLdsQDLHVxdLRUxGgI96IPesT9mtdbuoMeta } from "/opt/bookandgolf-front/pages/shopping-cart.vue?macro=true";
import { default as privacy_45policyNNk5m0lIFUEaVwUVH1FU_2K55TFmw2rH_Z6hpf_45JCOwMeta } from "/opt/bookandgolf-front/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordPt4m8b_X8sbeEsThfO7wTkdX2hOkoeWCbBwtIccQ3ukMeta } from "/opt/bookandgolf-front/pages/reset-password.vue?macro=true";
import { default as _91golfSlug_93CG8dOOD1p5iKBnfO2f4F03PBhErhgAUMDpALdJxn_456IMeta } from "/opt/bookandgolf-front/pages/golf/[golfSlug].vue?macro=true";
import { default as indexU62F8rKO6tYhY4Bqs1F5eBSch2_tRVo6uiJwZKqqTccMeta } from "/opt/bookandgolf-front/pages/reservations/index.vue?macro=true";
import { default as _91regionSlug_93cZ4TUZ0ebjjRv64EsaLtgW0aBnacZC_iIrENDthFpQ0Meta } from "/opt/bookandgolf-front/pages/region/[regionSlug].vue?macro=true";
import { default as _91golfId_93pthUQjsPolQIs6kTT6w7Pk07lTansEJy3Jk_45lDROgoYMeta } from "/opt/bookandgolf-front/pages/embed/golfs/[golfId].vue?macro=true";
import { default as _91reservationId_931W0GGl56zr2KJx5QbtT2o1qNpVSoHs6zsD6dmFRiu4gMeta } from "/opt/bookandgolf-front/pages/reservations/[reservationId].vue?macro=true";
export default [
  {
    name: "cgv",
    path: "/cgv",
    component: () => import("/opt/bookandgolf-front/pages/cgv.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/opt/bookandgolf-front/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/bookandgolf-front/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/bookandgolf-front/pages/login.vue")
  },
  {
    name: "reset",
    path: "/reset",
    component: () => import("/opt/bookandgolf-front/pages/reset.vue")
  },
  {
    name: "search",
    path: "/search/:productType/:locationType/:locationValue",
    meta: searchPUM0qx_UUMjaNmP4kn_45WCl2NX9Pw4jhZLa7N6SDBZGgMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/search.vue")
  },
  {
    name: "join-us",
    path: "/join-us",
    component: () => import("/opt/bookandgolf-front/pages/join-us.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profile2XF7ZogA6btWpnFBtKXPbIJ55bcRAPlUQQ6MT05OeWYMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/profile.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/opt/bookandgolf-front/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/opt/bookandgolf-front/pages/register.vue")
  },
  {
    name: "validate",
    path: "/validate",
    component: () => import("/opt/bookandgolf-front/pages/validate.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: favoritesd6mcePiIl9p18fBYY0U1qO9e7VvTk0coxtKFOs_DgRcMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/favorites.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    meta: promotionsCKQJrIv_hqiudeqn5eas4b0FzYYPucC1X0bkAMBlneYMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/promotions.vue")
  },
  {
    name: "legal-notice",
    path: "/legal-notice",
    component: () => import("/opt/bookandgolf-front/pages/legal-notice.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("/opt/bookandgolf-front/pages/product/[id].vue")
  },
  {
    name: "ratings-id",
    path: "/ratings/:id()",
    component: () => import("/opt/bookandgolf-front/pages/ratings/[id].vue")
  },
  {
    name: "partners-kady",
    path: "/partners/kady",
    meta: kadyg9jgc00RJ9XXfhyFiRW1SVqcSN1vKrF3nE06FoZwZF4Meta || {},
    component: () => import("/opt/bookandgolf-front/pages/partners/kady.vue")
  },
  {
    name: "shopping-cart",
    path: "/shopping-cart",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart.vue"),
    children: [
  {
    name: "shopping-cart-basket",
    path: "basket",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart/basket.vue")
  },
  {
    name: "shopping-cart-payment",
    path: "payment",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart/payment.vue")
  },
  {
    name: "shopping-cart-voucher",
    path: "voucher",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart/voucher.vue")
  },
  {
    name: "shopping-cart-confirmation",
    path: "confirmation",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart/confirmation.vue")
  },
  {
    name: "shopping-cart-pricing-id",
    path: "pricing/:id()",
    component: () => import("/opt/bookandgolf-front/pages/shopping-cart/pricing/[id].vue")
  }
]
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/bookandgolf-front/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/opt/bookandgolf-front/pages/reset-password.vue")
  },
  {
    name: "golf-golfSlug",
    path: "/golf/:golfSlug()",
    component: () => import("/opt/bookandgolf-front/pages/golf/[golfSlug].vue")
  },
  {
    name: "reservations",
    path: "/reservations",
    meta: indexU62F8rKO6tYhY4Bqs1F5eBSch2_tRVo6uiJwZKqqTccMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/reservations/index.vue")
  },
  {
    name: "region-regionSlug",
    path: "/region/:regionSlug()",
    component: () => import("/opt/bookandgolf-front/pages/region/[regionSlug].vue")
  },
  {
    name: "embed-golfs-golfId",
    path: "/embed/golfs/:golfId()",
    meta: _91golfId_93pthUQjsPolQIs6kTT6w7Pk07lTansEJy3Jk_45lDROgoYMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/embed/golfs/[golfId].vue")
  },
  {
    name: "reservations-reservationId",
    path: "/reservations/:reservationId()",
    meta: _91reservationId_931W0GGl56zr2KJx5QbtT2o1qNpVSoHs6zsD6dmFRiu4gMeta || {},
    component: () => import("/opt/bookandgolf-front/pages/reservations/[reservationId].vue")
  }
]